import { ProductCard } from './ProductCard';
import { ProductCardSkeleton } from './ProductCardSkeleton';
import type { PublicProduct } from './types';

export function ProductGrid({
  products,
  storeCode,
  browseStoreCode,
  loading = false,
  editorialBadge,
  allowDirectAdd = true,
  onAuthoritativeChange,
}: {
  products: PublicProduct[];
  storeCode?: string;
  browseStoreCode?: string;
  loading?: boolean;
  editorialBadge?: string;
  allowDirectAdd?: boolean;
  onAuthoritativeChange?: () => void;
}) {
  if (loading)
    return (
      <div className="product-grid" aria-label="Đang tải món">
        {Array.from({ length: 4 }, (_, i) => (
          <ProductCardSkeleton key={i} />
        ))}
      </div>
    );
  return (
    <div className="product-grid">
      {products.map((product, index) => (
        <ProductCard
          key={product.id ?? index}
          product={product}
          storeCode={storeCode}
          browseStoreCode={browseStoreCode}
          priority={index === 0}
          editorialBadge={editorialBadge}
          allowDirectAdd={allowDirectAdd}
          onAuthoritativeChange={onAuthoritativeChange}
        />
      ))}
    </div>
  );
}
